'use client';

import type { TableBlock } from '@jeraisonne/ai/visual-blocks';
import { MarkdownMath } from '../markdown-math';

export function TableBlockRenderer({ block }: { block: TableBlock }) {
  return (
    <div className="overflow-x-auto">
      <table className="min -w-[520px] w-full border-collapse text-xs sm:text-sm">
        {block.headers && block.headers.length > 0 && (
          <thead>
            <tr className="bg-ink-100">
              {block.headers.map((h, i) => (
                <th
                  key={i}
                  className="border-ink-200 text-ink-700 border px-3 py-2 text-left font-semibold"
                >
                  <MarkdownMath>{h}</MarkdownMath>
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {block.rows.map((row, ri) => (
            <tr key={ri} className={ri % 2 === 0 ? 'bg-white' : 'bg-ink-50'}>
              {row.map((cell, ci) => (
                <td key={ci} className="border-ink-200 text-ink-700 border px-3 py-2">
                  <MarkdownMath>{cell}</MarkdownMath>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
